import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './MainContent.css';
import './ContactForm.css';

const MainContent = () => {
  return (
    <main className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="text-center">
        <h2 id='about' className="large-font">About Us</h2>
        <p className="large-font">We sell Hawaiian style shaved ice topped with your favorite toppings! Book us for your next event!</p>
        <img 
          src={process.env.PUBLIC_URL + '/images/snowconeFamily.jpg'} 
          alt='about us' 
          className='img-fluid'
        />
        
        <h2 id='flavors' className="large-font">Our Flavors</h2>
        <p className="large-font">We offer a variety of flavors to satisfy your taste buds.</p>
        <ul className="list-unstyled large-font">
          <li>Blue Raspberry</li>
          <li>Bubblegum</li>
          <li>Cherry</li>
          <li>Dreamcicle</li>
          <li>Grape</li>
          <li>Miami Ice</li>
          <li>Orange</li>
          <li>Peach</li>
          <li>Shark Attack</li>
          <li>Sour Apple</li>
          <li>Spongebob</li>
          <li>Strawberry</li>
          <li>Strawberry Daiquiri</li>
          <li>Superman</li>
          <li>Tiger's Blood</li>
        </ul>
      </div>
    </main>
  );
};

const ContactForm = () => {
  // Replace formData with actual contact information
  const contactInfo = {
    name: 'Keri Allen',
    email: 'k.allen4433@gmail.com',
    phone: '865-300-2835'
  };

  return (
    <section id="contact" className="contact-section py-5 full bg-white">
      <div className="container">
        <h2 className="text-center mb-4">Contact Us</h2>
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="contact-info large-font">
              <p><strong>Name:</strong> {contactInfo.name}</p>
              <p><strong>Email:</strong> {contactInfo.email}</p>
              <p><strong>Phone:</strong> {contactInfo.phone}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { MainContent, ContactForm };